import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { ResumoPedido } from './../models/resumoPedido';
import { Financa } from '../models/financa';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import {
  Dashboard,
  ResultadosPeriodoDashboard,
  ResultDadosGraficos,
  ResultTotais,
  ResultVendasUltOrcPed
} from '../models/dashboard';
import { VendaEntrega } from '../models/venda-entrega';
import { QtdProduto } from '../models/produto';
import { ItemPedido, Pedido } from '../models/pedido';
import { InfoRegra } from '../models/InfoRegra';
import { InfoRegraFormula } from '../models/info-regra-formula';
import { DadosCalculo } from '../models/dados-calculo';
import { Observable } from 'rxjs';
import { TipoAplicacao } from '../models/enum';
import { LogVendaCupom } from '../models/log-venda-cupom';
import { PedidoLista } from '../models/pedido-lista';
import { VendaFormaPag } from '../models/venda-forma-pag';
import { Fileira } from '../models/fileira';
import { VendaResposta } from '../models/venda-resposta';

@Injectable({
  providedIn: 'root'
})
export class PedidoService {
  constructor(
    private globalService: GlobalService,
    private http: HttpClient,
    private utilitarioService: UtilitarioService
  ) {}

  bC_Pedido(
    idCupom: string,
    atualizarValores: boolean = false,
    buscarEstoque: boolean = true,
    duplicando: boolean = false
  ): Observable<Pedido> {
    const parametros = new HttpParams()
      .set('idCupom', idCupom)
      .set('atualizarValores', atualizarValores.toString())
      .set('buscarEstoque', buscarEstoque.toString())
      .set('duplicando', duplicando.toString());

    return this.http.get<Pedido>(`${globals.apiUrl}/api/Pedido/BC_Pedido`, { params: parametros });
  }

  bC_Itens(
    idCupom: string,
    atualizarValores: boolean = false,
    buscarEstoque: boolean = true,
    buscarFoto: boolean = true,
    duplicando: boolean = false
  ): Observable<ItemPedido[]> {
    const parametros = new HttpParams()
      .set('idCupom', idCupom)
      .set('atualizarValores', atualizarValores.toString())
      .set('buscarEstoque', buscarEstoque.toString())
      .set('buscarFoto', buscarFoto.toString())
      .set('duplicando', duplicando.toString());

    return this.http.get<ItemPedido[]>(`${globals.apiUrl}/api/Pedido/BC_Itens`, { params: parametros });
  }

  bC_Fileiras(idCupom: string, buscarEstoque: boolean = true): Observable<Fileira[]> {
    const parametros = new HttpParams().set('idCupom', idCupom).set('buscarEstoque', buscarEstoque.toString());

    return this.http.get<Fileira[]>(`${globals.apiUrl}/api/Pedido/BC_Fileiras`, { params: parametros });
  }

  bC_EnderecoDeEntrega(idCupom: string): Observable<VendaEntrega> {
    return this.http.get<VendaEntrega>(`${globals.apiUrl}/api/Pedido/BC_EnderecoDeEntrega`, { params: { idCupom } });
  }

  bC_Respostas(idCupom: string): Observable<VendaResposta[]> {
    return this.http.get<VendaResposta[]>(`${globals.apiUrl}/api/Pedido/BC_Respostas`, { params: { idCupom } });
  }

  bC_LimDesc(idCupom: string): Observable<number> {
    return this.http.get<number>(`${globals.apiUrl}/api/Pedido/BC_LimDesc`, { params: { idCupom } });
  }

  consultarComPaginacaoMonitor(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    inicio,
    fim,
    nomeCliente,
    cupom,
    status,
    vendedor,
    etapas,
    mostrarTodos,
    acompanhamento,
    idIntegrador,
    orcStatus,
    forma?,
    condicao?,
    valorIni?,
    valorFim?,
    tags?,
    monitor?,
    repasse?,
    repasseStatus?,
    tipoFiltroDataMonitor?,
    idUsuarioIntegrador?,
    referencia?,
    idFornecedor?,
    codErp?,
    filtroClassificacao?,
    ordemMonitor?,
    buscarTags?,
    buscarSeguros?,
    buscarFormasPagamento?,
    buscarCamposPersonalizados?,
    nfe?,
    valorComprovanteDe?,
    valorComprovanteAte?,
    pendencias?,
    tipoLocalizacao?,
    possuiVendaDireta?,
    vFiltroDescDe?,
    vFiltroDescAte?,
    possuiServico?,
    tipoFrete?,
    tipoPendencia?,
    substituicao?,
    possuiRespostaAnaliseDesconto?,
    pesquisarPorTime?,
    cidadeCd?,
    codErpProduto?
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('dInicio', inicio ? inicio : '')
      .set('dFim', fim ? fim : '')
      .set('nomeCliente', nomeCliente ? nomeCliente : '')
      .set('cupom', cupom ? cupom : '')
      .set('status', status !== undefined && status !== null ? status : '')
      .set('vendedor', vendedor !== undefined && vendedor !== null ? vendedor : '')
      .set('etapas', etapas !== undefined && etapas !== null ? etapas : '')
      .set('mostrarTodos', mostrarTodos)
      .set('monitoramento', acompanhamento)
      .set('pendencias', pendencias !== undefined && pendencias !== null ? pendencias : '');

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    if (forma !== undefined && forma !== null) {
      parametros = parametros.set('forma', forma);
    }
    if (condicao !== undefined && condicao !== null) {
      parametros = parametros.set('condicao', condicao);
    }
    if (valorIni !== undefined && valorIni !== null) {
      parametros = parametros.set('valorIni', valorIni);
    }
    if (valorFim !== undefined && valorFim !== null) {
      parametros = parametros.set('valorFim', valorFim);
    }
    if (orcStatus !== undefined && orcStatus !== null) {
      parametros = parametros.set('orcStatus', orcStatus);
    }
    if (tags !== undefined && tags !== null) {
      parametros = parametros.set('tags', tags);
    }
    if (monitor !== undefined && monitor !== null) {
      parametros = parametros.set('monitor', monitor);
    }
    if (repasse !== undefined && repasse !== null) {
      parametros = parametros.set('repasse', repasse);
    }

    if (repasseStatus !== undefined && repasseStatus !== null) {
      parametros = parametros.set('repasseStatus', repasseStatus);
    }

    if (tipoFiltroDataMonitor !== undefined && tipoFiltroDataMonitor !== null) {
      parametros = parametros.set('tipoFiltroDataMonitor', tipoFiltroDataMonitor);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (referencia !== undefined && referencia !== null) {
      parametros = parametros.set('referencia', referencia);
    }

    if (idFornecedor !== undefined && idFornecedor !== null) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if (codErp !== undefined && codErp !== null) {
      parametros = parametros.set('codErp', codErp);
    }

    if (filtroClassificacao !== undefined && filtroClassificacao !== null) {
      parametros = parametros.set('filtroClassificacao', filtroClassificacao);
    }

    if (ordemMonitor !== undefined && ordemMonitor !== null) {
      parametros = parametros.set('ordemMonitor', ordemMonitor);
    }

    if (buscarTags !== undefined && buscarTags !== null) {
      parametros = parametros.set('buscarTags', buscarTags);
    }

    if (buscarSeguros !== undefined && buscarSeguros !== null) {
      parametros = parametros.set('buscarSeguros', buscarSeguros);
    }

    if (buscarFormasPagamento !== undefined && buscarFormasPagamento !== null) {
      parametros = parametros.set('buscarFormasPagamento', buscarFormasPagamento);
    }

    if (buscarCamposPersonalizados !== undefined && buscarCamposPersonalizados !== null) {
      parametros = parametros.set('buscarCamposPersonalizados', buscarCamposPersonalizados);
    }

    if (nfe !== undefined && nfe !== null) {
      parametros = parametros.set('nfe', nfe);
    }

    if (valorComprovanteDe !== undefined && valorComprovanteDe !== null) {
      parametros = parametros.set('valorComprovanteIni', valorComprovanteDe);
    }

    if (valorComprovanteAte !== undefined && valorComprovanteAte !== null) {
      parametros = parametros.set('valorComprovanteFim', valorComprovanteAte);
    }

    if (tipoLocalizacao !== undefined && tipoLocalizacao !== null) {
      const eRural = tipoLocalizacao === 0 ? '1' : '0';

      parametros = parametros.set('tipoLocalizacao', eRural);
    }

    if (possuiVendaDireta !== undefined && possuiVendaDireta !== null) {
      parametros = parametros.set('possuiVendaDireta', possuiVendaDireta);
    }

    if (vFiltroDescDe != undefined && vFiltroDescDe != null && vFiltroDescAte && vFiltroDescAte) {
      parametros = parametros.set('vFiltroDescDe', vFiltroDescDe);
      parametros = parametros.set('vFiltroDescAte', vFiltroDescAte);
    }

    if (possuiServico !== undefined && possuiServico !== null) {
      parametros = parametros.set('possuiServico', (possuiServico === 1).toString());
    }

    if (tipoFrete !== undefined && tipoFrete !== null) {
      parametros = parametros.set('tipoFrete', tipoFrete);
    }

    if (tipoPendencia !== undefined && tipoPendencia !== null) {
      parametros = parametros.set('tipoPendencia', tipoPendencia);
    }

    if (substituicao !== undefined && substituicao !== null) {
      parametros = parametros.set('substituicao', substituicao);
    }

    if (possuiRespostaAnaliseDesconto !== undefined && possuiRespostaAnaliseDesconto !== null) {
      parametros = parametros.set('possuiRespostaAnaliseDesconto', possuiRespostaAnaliseDesconto);
    }

    if (pesquisarPorTime !== undefined && pesquisarPorTime !== null) {
      parametros = parametros.set('pesquisarPorTime', pesquisarPorTime);
    }

    if (cidadeCd !== undefined && cidadeCd !== null) {
      parametros = parametros.set('cidadeCD', cidadeCd);
    }

    if (codErpProduto !== undefined && codErpProduto !== null) {
      parametros = parametros.set('codErpProduto', codErpProduto);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/ListaPagMonitor', {
      params: parametros
    });
  }

  consultarComPaginacao(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    inicio,
    fim,
    nomeCliente,
    cupom,
    status,
    vendedor,
    etapas,
    mostrarTodos,
    acompanhamento,
    idIntegrador,
    orcStatus,
    forma?,
    condicao?,
    valorIni?,
    valorFim?,
    tags?,
    monitor?,
    repasse?,
    repasseStatus?,
    tipoFiltroDataMonitor?,
    idUsuarioIntegrador?,
    referencia?,
    idFornecedor?,
    codErp?,
    filtroClassificacao?,
    ordemMonitor?,
    buscarTags?,
    buscarSeguros?,
    buscarFormasPagamento?,
    buscarCamposPersonalizados?,
    nfe?,
    valorComprovanteDe?,
    valorComprovanteAte?,
    pendencias?,
    tipoLocalizacao?,
    possuiVendaDireta?,
    vFiltroDescDe?,
    vFiltroDescAte?,
    possuiServico?,
    tipoFrete?,
    tipoPendencia?,
    substituicao?,
    possuiRespostaAnaliseDesconto?,
    pesquisarPorTime?,
    cidadeCd?
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('dInicio', inicio ? inicio : '')
      .set('dFim', fim ? fim : '')
      .set('nomeCliente', nomeCliente ? nomeCliente : '')
      .set('cupom', cupom ? cupom : '')
      .set('status', status !== undefined && status !== null ? status : '')
      .set('vendedor', vendedor !== undefined && vendedor !== null ? vendedor : '')
      .set('etapas', etapas !== undefined && etapas !== null ? etapas : '')
      .set('mostrarTodos', mostrarTodos)
      .set('monitoramento', acompanhamento)
      .set('pendencias', pendencias !== undefined && pendencias !== null ? pendencias : '');

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    if (forma !== undefined && forma !== null) {
      parametros = parametros.set('forma', forma);
    }
    if (condicao !== undefined && condicao !== null) {
      parametros = parametros.set('condicao', condicao);
    }
    if (valorIni !== undefined && valorIni !== null) {
      parametros = parametros.set('valorIni', valorIni);
    }
    if (valorFim !== undefined && valorFim !== null) {
      parametros = parametros.set('valorFim', valorFim);
    }
    if (orcStatus !== undefined && orcStatus !== null) {
      parametros = parametros.set('orcStatus', orcStatus);
    }
    if (tags !== undefined && tags !== null) {
      parametros = parametros.set('tags', tags);
    }
    if (monitor !== undefined && monitor !== null) {
      parametros = parametros.set('monitor', monitor);
    }
    if (repasse !== undefined && repasse !== null) {
      parametros = parametros.set('repasse', repasse);
    }

    if (repasseStatus !== undefined && repasseStatus !== null) {
      parametros = parametros.set('repasseStatus', repasseStatus);
    }

    if (tipoFiltroDataMonitor !== undefined && tipoFiltroDataMonitor !== null) {
      parametros = parametros.set('tipoFiltroDataMonitor', tipoFiltroDataMonitor);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (referencia !== undefined && referencia !== null) {
      parametros = parametros.set('referencia', referencia);
    }

    if (idFornecedor !== undefined && idFornecedor !== null) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if (codErp !== undefined && codErp !== null) {
      parametros = parametros.set('codErp', codErp);
    }

    if (filtroClassificacao !== undefined && filtroClassificacao !== null) {
      parametros = parametros.set('filtroClassificacao', filtroClassificacao);
    }

    if (ordemMonitor !== undefined && ordemMonitor !== null) {
      parametros = parametros.set('ordemMonitor', ordemMonitor);
    }

    if (buscarTags !== undefined && buscarTags !== null) {
      parametros = parametros.set('buscarTags', buscarTags);
    }

    if (buscarSeguros !== undefined && buscarSeguros !== null) {
      parametros = parametros.set('buscarSeguros', buscarSeguros);
    }

    if (buscarFormasPagamento !== undefined && buscarFormasPagamento !== null) {
      parametros = parametros.set('buscarFormasPagamento', buscarFormasPagamento);
    }

    if (buscarCamposPersonalizados !== undefined && buscarCamposPersonalizados !== null) {
      parametros = parametros.set('buscarCamposPersonalizados', buscarCamposPersonalizados);
    }

    if (nfe !== undefined && nfe !== null) {
      parametros = parametros.set('nfe', nfe);
    }

    if (valorComprovanteDe !== undefined && valorComprovanteDe !== null) {
      parametros = parametros.set('valorComprovanteIni', valorComprovanteDe);
    }

    if (valorComprovanteAte !== undefined && valorComprovanteAte !== null) {
      parametros = parametros.set('valorComprovanteFim', valorComprovanteAte);
    }

    if (tipoLocalizacao !== undefined && tipoLocalizacao !== null) {
      const eRural = tipoLocalizacao === 0 ? '1' : '0';

      parametros = parametros.set('tipoLocalizacao', eRural);
    }

    if (possuiVendaDireta !== undefined && possuiVendaDireta !== null) {
      parametros = parametros.set('possuiVendaDireta', possuiVendaDireta);
    }

    if (vFiltroDescDe != undefined && vFiltroDescDe != null && vFiltroDescAte && vFiltroDescAte) {
      parametros = parametros.set('vFiltroDescDe', vFiltroDescDe);
      parametros = parametros.set('vFiltroDescAte', vFiltroDescAte);
    }

    if (possuiServico !== undefined && possuiServico !== null) {
      parametros = parametros.set('possuiServico', (possuiServico === 1).toString());
    }

    if (tipoFrete !== undefined && tipoFrete !== null) {
      parametros = parametros.set('tipoFrete', tipoFrete);
    }

    if (tipoPendencia !== undefined && tipoPendencia !== null) {
      parametros = parametros.set('tipoPendencia', tipoPendencia);
    }

    if (substituicao !== undefined && substituicao !== null) {
      parametros = parametros.set('substituicao', substituicao);
    }

    if (possuiRespostaAnaliseDesconto !== undefined && possuiRespostaAnaliseDesconto !== null) {
      parametros = parametros.set('possuiRespostaAnaliseDesconto', possuiRespostaAnaliseDesconto);
    }

    if (pesquisarPorTime !== undefined && pesquisarPorTime !== null) {
      parametros = parametros.set('pesquisarPorTime', pesquisarPorTime);
    }

    if (cidadeCd !== undefined && cidadeCd !== null) {
      parametros = parametros.set('cidadeCD', cidadeCd);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/ListaPag', {
      params: parametros
    });
  }

  consultarTotalPaginacao(
    inicio,
    fim,
    nomeCliente,
    cupom,
    status,
    vendedor,
    etapas,
    mostrarTodos,
    acompanhamento,
    idIntegrador,
    orcStatus,
    forma?,
    condicao?,
    valorIni?,
    valorFim?,
    tags?,
    monitor?,
    repasse?,
    repasseStatus?,
    tipoFiltroDataMonitor?,
    idUsuarioIntegrador?,
    referencia?,
    idFornecedor?,
    codErp?,
    filtroClassificacao?,
    ordemMonitor?,
    buscarTags?,
    buscarSeguros?,
    buscarFormasPagamento?,
    buscarCamposPersonalizados?,
    nfe?,
    valorComprovanteDe?,
    valorComprovanteAte?,
    pendencias?,
    tipoLocalizacao?,
    possuiVendaDireta?,
    vFiltroDescDe?,
    vFiltroDescAte?,
    possuiServico?,
    tipoFrete?,
    tipoPendencia?,
    substituicao?,
    possuiRespostaAnaliseDesconto?,
    pesquisarPorTime?,
    cidadeCd?
  ) {
    let parametros = new HttpParams()
      .set('dInicio', inicio ? inicio : '')
      .set('dFim', fim ? fim : '')
      .set('nomeCliente', nomeCliente ? nomeCliente : '')
      .set('cupom', cupom ? cupom : '')
      .set('status', status !== undefined && status !== null ? status : '')
      .set('vendedor', vendedor !== undefined && vendedor !== null ? vendedor : '')
      .set('etapas', etapas !== undefined && etapas !== null ? etapas : '')
      .set('mostrarTodos', mostrarTodos)
      .set('monitoramento', acompanhamento)
      .set('pendencias', pendencias !== undefined && pendencias !== null ? pendencias : '');

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    if (forma !== undefined && forma !== null) {
      parametros = parametros.set('forma', forma);
    }
    if (condicao !== undefined && condicao !== null) {
      parametros = parametros.set('condicao', condicao);
    }
    if (valorIni !== undefined && valorIni !== null) {
      parametros = parametros.set('valorIni', valorIni);
    }
    if (valorFim !== undefined && valorFim !== null) {
      parametros = parametros.set('valorFim', valorFim);
    }
    if (orcStatus !== undefined && orcStatus !== null) {
      parametros = parametros.set('orcStatus', orcStatus);
    }
    if (tags !== undefined && tags !== null) {
      parametros = parametros.set('tags', tags);
    }
    if (monitor !== undefined && monitor !== null) {
      parametros = parametros.set('monitor', monitor);
    }
    if (repasse !== undefined && repasse !== null) {
      parametros = parametros.set('repasse', repasse);
    }

    if (repasseStatus !== undefined && repasseStatus !== null) {
      parametros = parametros.set('repasseStatus', repasseStatus);
    }

    if (tipoFiltroDataMonitor !== undefined && tipoFiltroDataMonitor !== null) {
      parametros = parametros.set('tipoFiltroDataMonitor', tipoFiltroDataMonitor);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (referencia !== undefined && referencia !== null) {
      parametros = parametros.set('referencia', referencia);
    }

    if (idFornecedor !== undefined && idFornecedor !== null) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if (codErp !== undefined && codErp !== null) {
      parametros = parametros.set('codErp', codErp);
    }

    if (filtroClassificacao !== undefined && filtroClassificacao !== null) {
      parametros = parametros.set('filtroClassificacao', filtroClassificacao);
    }

    if (ordemMonitor !== undefined && ordemMonitor !== null) {
      parametros = parametros.set('ordemMonitor', ordemMonitor);
    }

    if (buscarTags !== undefined && buscarTags !== null) {
      parametros = parametros.set('buscarTags', buscarTags);
    }

    if (buscarSeguros !== undefined && buscarSeguros !== null) {
      parametros = parametros.set('buscarSeguros', buscarSeguros);
    }

    if (buscarFormasPagamento !== undefined && buscarFormasPagamento !== null) {
      parametros = parametros.set('buscarFormasPagamento', buscarFormasPagamento);
    }

    if (buscarCamposPersonalizados !== undefined && buscarCamposPersonalizados !== null) {
      parametros = parametros.set('buscarCamposPersonalizados', buscarCamposPersonalizados);
    }

    if (nfe !== undefined && nfe !== null) {
      parametros = parametros.set('nfe', nfe);
    }

    if (valorComprovanteDe !== undefined && valorComprovanteDe !== null) {
      parametros = parametros.set('valorComprovanteIni', valorComprovanteDe);
    }

    if (valorComprovanteAte !== undefined && valorComprovanteAte !== null) {
      parametros = parametros.set('valorComprovanteFim', valorComprovanteAte);
    }

    if (tipoLocalizacao !== undefined && tipoLocalizacao !== null) {
      const eRural = tipoLocalizacao === 0 ? '1' : '0';

      parametros = parametros.set('tipoLocalizacao', eRural);
    }

    if (possuiVendaDireta !== undefined && possuiVendaDireta !== null) {
      parametros = parametros.set('possuiVendaDireta', possuiVendaDireta);
    }

    if (vFiltroDescDe != undefined && vFiltroDescDe != null && vFiltroDescAte && vFiltroDescAte) {
      parametros = parametros.set('vFiltroDescDe', vFiltroDescDe);
      parametros = parametros.set('vFiltroDescAte', vFiltroDescAte);
    }

    if (possuiServico !== undefined && possuiServico !== null) {
      parametros = parametros.set('possuiServico', (possuiServico === 1).toString());
    }

    if (tipoFrete !== undefined && tipoFrete !== null) {
      parametros = parametros.set('tipoFrete', tipoFrete);
    }

    if (tipoPendencia !== undefined && tipoPendencia !== null) {
      parametros = parametros.set('tipoPendencia', tipoPendencia);
    }

    if (substituicao !== undefined && substituicao !== null) {
      parametros = parametros.set('substituicao', substituicao);
    }

    if (possuiRespostaAnaliseDesconto !== undefined && possuiRespostaAnaliseDesconto !== null) {
      parametros = parametros.set('possuiRespostaAnaliseDesconto', possuiRespostaAnaliseDesconto);
    }

    if (pesquisarPorTime !== undefined && pesquisarPorTime !== null) {
      parametros = parametros.set('pesquisarPorTime', pesquisarPorTime);
    }

    if (cidadeCd !== undefined && cidadeCd !== null) {
      parametros = parametros.set('cidadeCD', cidadeCd);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/TotalPag', {
      params: parametros
    });
  }

  consultarTotalPaginacaoMonitor(
    inicio,
    fim,
    nomeCliente,
    cupom,
    status,
    vendedor,
    etapas,
    mostrarTodos,
    acompanhamento,
    idIntegrador,
    orcStatus,
    forma?,
    condicao?,
    valorIni?,
    valorFim?,
    tags?,
    monitor?,
    repasse?,
    repasseStatus?,
    tipoFiltroDataMonitor?,
    idUsuarioIntegrador?,
    referencia?,
    idFornecedor?,
    codErp?,
    filtroClassificacao?,
    ordemMonitor?,
    buscarTags?,
    buscarSeguros?,
    buscarFormasPagamento?,
    buscarCamposPersonalizados?,
    nfe?,
    valorComprovanteDe?,
    valorComprovanteAte?,
    pendencias?,
    tipoLocalizacao?,
    possuiVendaDireta?,
    vFiltroDescDe?,
    vFiltroDescAte?,
    possuiServico?,
    tipoFrete?,
    tipoPendencia?,
    substituicao?,
    possuiRespostaAnaliseDesconto?,
    pesquisarPorTime?,
    cidadeCd?,
    codErpProduto?
  ) {
    let parametros = new HttpParams()
      .set('dInicio', inicio ? inicio : '')
      .set('dFim', fim ? fim : '')
      .set('nomeCliente', nomeCliente ? nomeCliente : '')
      .set('cupom', cupom ? cupom : '')
      .set('status', status !== undefined && status !== null ? status : '')
      .set('vendedor', vendedor !== undefined && vendedor !== null ? vendedor : '')
      .set('etapas', etapas !== undefined && etapas !== null ? etapas : '')
      .set('mostrarTodos', mostrarTodos)
      .set('monitoramento', acompanhamento)
      .set('pendencias', pendencias !== undefined && pendencias !== null ? pendencias : '');

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    if (forma !== undefined && forma !== null) {
      parametros = parametros.set('forma', forma);
    }
    if (condicao !== undefined && condicao !== null) {
      parametros = parametros.set('condicao', condicao);
    }
    if (valorIni !== undefined && valorIni !== null) {
      parametros = parametros.set('valorIni', valorIni);
    }
    if (valorFim !== undefined && valorFim !== null) {
      parametros = parametros.set('valorFim', valorFim);
    }
    if (orcStatus !== undefined && orcStatus !== null) {
      parametros = parametros.set('orcStatus', orcStatus);
    }
    if (tags !== undefined && tags !== null) {
      parametros = parametros.set('tags', tags);
    }
    if (monitor !== undefined && monitor !== null) {
      parametros = parametros.set('monitor', monitor);
    }
    if (repasse !== undefined && repasse !== null) {
      parametros = parametros.set('repasse', repasse);
    }

    if (repasseStatus !== undefined && repasseStatus !== null) {
      parametros = parametros.set('repasseStatus', repasseStatus);
    }

    if (tipoFiltroDataMonitor !== undefined && tipoFiltroDataMonitor !== null) {
      parametros = parametros.set('tipoFiltroDataMonitor', tipoFiltroDataMonitor);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (referencia !== undefined && referencia !== null) {
      parametros = parametros.set('referencia', referencia);
    }

    if (idFornecedor !== undefined && idFornecedor !== null) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if (codErp !== undefined && codErp !== null) {
      parametros = parametros.set('codErp', codErp);
    }

    if (filtroClassificacao !== undefined && filtroClassificacao !== null) {
      parametros = parametros.set('filtroClassificacao', filtroClassificacao);
    }

    if (ordemMonitor !== undefined && ordemMonitor !== null) {
      parametros = parametros.set('ordemMonitor', ordemMonitor);
    }

    if (buscarTags !== undefined && buscarTags !== null) {
      parametros = parametros.set('buscarTags', buscarTags);
    }

    if (buscarSeguros !== undefined && buscarSeguros !== null) {
      parametros = parametros.set('buscarSeguros', buscarSeguros);
    }

    if (buscarFormasPagamento !== undefined && buscarFormasPagamento !== null) {
      parametros = parametros.set('buscarFormasPagamento', buscarFormasPagamento);
    }

    if (buscarCamposPersonalizados !== undefined && buscarCamposPersonalizados !== null) {
      parametros = parametros.set('buscarCamposPersonalizados', buscarCamposPersonalizados);
    }

    if (nfe !== undefined && nfe !== null) {
      parametros = parametros.set('nfe', nfe);
    }

    if (valorComprovanteDe !== undefined && valorComprovanteDe !== null) {
      parametros = parametros.set('valorComprovanteIni', valorComprovanteDe);
    }

    if (valorComprovanteAte !== undefined && valorComprovanteAte !== null) {
      parametros = parametros.set('valorComprovanteFim', valorComprovanteAte);
    }

    if (tipoLocalizacao !== undefined && tipoLocalizacao !== null) {
      const eRural = tipoLocalizacao === 0 ? '1' : '0';

      parametros = parametros.set('tipoLocalizacao', eRural);
    }

    if (possuiVendaDireta !== undefined && possuiVendaDireta !== null) {
      parametros = parametros.set('possuiVendaDireta', possuiVendaDireta);
    }

    if (vFiltroDescDe != undefined && vFiltroDescDe != null && vFiltroDescAte && vFiltroDescAte) {
      parametros = parametros.set('vFiltroDescDe', vFiltroDescDe);
      parametros = parametros.set('vFiltroDescAte', vFiltroDescAte);
    }

    if (possuiServico !== undefined && possuiServico !== null) {
      parametros = parametros.set('possuiServico', (possuiServico === 1).toString());
    }

    if (tipoFrete !== undefined && tipoFrete !== null) {
      parametros = parametros.set('tipoFrete', tipoFrete);
    }

    if (tipoPendencia !== undefined && tipoPendencia !== null) {
      parametros = parametros.set('tipoPendencia', tipoPendencia);
    }

    if (substituicao !== undefined && substituicao !== null) {
      parametros = parametros.set('substituicao', substituicao);
    }

    if (possuiRespostaAnaliseDesconto !== undefined && possuiRespostaAnaliseDesconto !== null) {
      parametros = parametros.set('possuiRespostaAnaliseDesconto', possuiRespostaAnaliseDesconto);
    }

    if (pesquisarPorTime !== undefined && pesquisarPorTime !== null) {
      parametros = parametros.set('pesquisarPorTime', pesquisarPorTime);
    }

    if (cidadeCd !== undefined && cidadeCd !== null) {
      parametros = parametros.set('cidadeCD', cidadeCd);
    }

    if (codErpProduto !== undefined && codErpProduto !== null) {
      parametros = parametros.set('codErpProduto', codErpProduto);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/TotalPagMonitor', {
      params: parametros
    });
  }

  consultarTotaisMonitores(
    inicio,
    fim,
    nomeCliente,
    cupom,
    status,
    vendedor,
    etapas,
    mostrarTodos,
    acompanhamento,
    idIntegrador,
    orcStatus,
    forma?,
    condicao?,
    valorIni?,
    valorFim?,
    tags?,
    monitor?,
    repasse?,
    repasseStatus?,
    tipoFiltroDataMonitor?,
    idUsuarioIntegrador?,
    referencia?,
    idFornecedor?,
    codErp?,
    filtroClassificacao?,
    nfe?,
    pendencias?,
    tipoLocalizacao?,
    possuiVendaDireta?,
    vFiltroDescDe?,
    vFiltroDescAte?,
    possuiServico?,
    tipoFrete?,
    tipoPendencia?,
    substituicao?,
    possuiRespostaAnaliseDesconto?,
    pesquisarPorTime?
  ) {
    let parametros = new HttpParams()
      .set('dInicio', inicio ? inicio : '')
      .set('dFim', fim ? fim : '')
      .set('nomeCliente', nomeCliente ? nomeCliente : '')
      .set('cupom', cupom ? cupom : '')
      .set('status', status !== undefined && status !== null ? status : '')
      .set('vendedor', vendedor !== undefined && vendedor !== null ? vendedor : '')
      .set('etapas', etapas !== undefined && etapas !== null ? etapas : '')
      .set('mostrarTodos', mostrarTodos)
      .set('monitoramento', acompanhamento)
      .set('pendencias', pendencias !== undefined && pendencias !== null ? pendencias : '');

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    if (forma !== undefined && forma !== null) {
      parametros = parametros.set('forma', forma);
    }
    if (condicao !== undefined && condicao !== null) {
      parametros = parametros.set('condicao', condicao);
    }
    if (valorIni !== undefined && valorIni !== null) {
      parametros = parametros.set('valorIni', valorIni);
    }
    if (valorFim !== undefined && valorFim !== null) {
      parametros = parametros.set('valorFim', valorFim);
    }
    if (orcStatus !== undefined && orcStatus !== null) {
      parametros = parametros.set('orcStatus', orcStatus);
    }
    if (tags !== undefined && tags !== null) {
      parametros = parametros.set('tags', tags);
    }
    if (monitor !== undefined && monitor !== null) {
      parametros = parametros.set('monitor', monitor);
    }
    if (repasse !== undefined && repasse !== null) {
      parametros = parametros.set('repasse', repasse);
    }

    if (repasseStatus !== undefined && repasseStatus !== null) {
      parametros = parametros.set('repasseStatus', repasseStatus);
    }

    if (tipoFiltroDataMonitor !== undefined && tipoFiltroDataMonitor !== null) {
      parametros = parametros.set('tipoFiltroDataMonitor', tipoFiltroDataMonitor);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (referencia !== undefined && referencia !== null) {
      parametros = parametros.set('referencia', referencia);
    }

    if (idFornecedor !== undefined && idFornecedor !== null) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if (codErp !== undefined && codErp !== null) {
      parametros = parametros.set('codErp', codErp);
    }

    if (filtroClassificacao !== undefined && filtroClassificacao !== null) {
      parametros = parametros.set('filtroClassificacao', filtroClassificacao);
    }

    if (nfe !== undefined && nfe !== null) {
      parametros = parametros.set('nfe', nfe);
    }

    if (tipoLocalizacao !== undefined && tipoLocalizacao !== null) {
      const eRural = tipoLocalizacao === 0 ? '1' : '0';

      parametros = parametros.set('tipoLocalizacao', eRural);
    }

    if (possuiVendaDireta !== undefined && possuiVendaDireta !== null) {
      parametros = parametros.set('possuiVendaDireta', possuiVendaDireta);
    }

    if (vFiltroDescDe != undefined && vFiltroDescDe != null && vFiltroDescAte && vFiltroDescAte) {
      parametros = parametros.set('vFiltroDescDe', vFiltroDescDe);
      parametros = parametros.set('vFiltroDescAte', vFiltroDescAte);
    }

    if (possuiServico !== undefined && possuiServico !== null) {
      parametros = parametros.set('possuiServico', (possuiServico === 1).toString());
    }

    if (tipoFrete !== undefined && tipoFrete !== null) {
      parametros = parametros.set('tipoFrete', tipoFrete);
    }

    if (tipoPendencia !== undefined && tipoPendencia !== null) {
      parametros = parametros.set('tipoPendencia', tipoPendencia);
    }

    if (substituicao !== undefined && substituicao !== null) {
      parametros = parametros.set('substituicao', substituicao);
    }

    if (possuiRespostaAnaliseDesconto !== undefined && possuiRespostaAnaliseDesconto !== null) {
      parametros = parametros.set('possuiRespostaAnaliseDesconto', possuiRespostaAnaliseDesconto);
    }

    if (pesquisarPorTime !== undefined && pesquisarPorTime !== null) {
      parametros = parametros.set('pesquisarPorTime', pesquisarPorTime);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarTotaisMonitores', {
      params: parametros
    });
  }

  exportarConsultaMonitor(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    inicio,
    fim,
    nomeCliente,
    cupom,
    status,
    vendedor,
    etapas,
    mostrarTodos,
    acompanhamento,
    idIntegrador,
    orcStatus,
    forma?,
    condicao?,
    valorIni?,
    valorFim?,
    tags?,
    monitor?,
    repasse?,
    repasseStatus?,
    tipoFiltroDataMonitor?,
    idUsuarioIntegrador?,
    referencia?,
    idFornecedor?,
    codErp?,
    ordemMonitor?,
    nfe?,
    tipoLocalizacao?,
    possuiVendaDireta?,
    vFiltroDescDe?,
    vFiltroDescAte?,
    possuiServico?,
    tipoFrete?,
    tipoPendencia?,
    pendencias?,
    substituicao?,
    possuiRespostaAnaliseDesconto?,
    pesquisarPorTime?,
    cidadeCd?,
    codErpProduto?
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('dInicio', inicio ? inicio : '')
      .set('dFim', fim ? fim : '')
      .set('nomeCliente', nomeCliente ? nomeCliente : '')
      .set('cupom', cupom ? cupom : '')
      .set('status', status !== undefined && status !== null ? status : '')
      .set('vendedor', vendedor !== undefined && vendedor !== null ? vendedor : '')
      .set('etapas', etapas !== undefined && etapas !== null ? etapas : '')
      .set('mostrarTodos', mostrarTodos)
      .set('monitoramento', acompanhamento)
      .set('pendencias', pendencias !== undefined && pendencias !== null ? pendencias : '');

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    if (forma !== undefined && forma !== null) {
      parametros = parametros.set('forma', forma);
    }
    if (condicao !== undefined && condicao !== null) {
      parametros = parametros.set('condicao', condicao);
    }
    if (valorIni !== undefined && valorIni !== null) {
      parametros = parametros.set('valorIni', valorIni);
    }
    if (valorFim !== undefined && valorFim !== null) {
      parametros = parametros.set('valorFim', valorFim);
    }
    if (orcStatus !== undefined && orcStatus !== null) {
      parametros = parametros.set('orcStatus', orcStatus);
    }
    if (tags !== undefined && tags !== null) {
      parametros = parametros.set('tags', tags);
    }
    if (monitor !== undefined && monitor !== null) {
      parametros = parametros.set('monitor', monitor);
    }
    if (repasse !== undefined && repasse !== null) {
      parametros = parametros.set('repasse', repasse);
    }

    if (repasseStatus !== undefined && repasseStatus !== null) {
      parametros = parametros.set('repasseStatus', repasseStatus);
    }

    if (tipoFiltroDataMonitor !== undefined && tipoFiltroDataMonitor !== null) {
      parametros = parametros.set('tipoFiltroDataMonitor', tipoFiltroDataMonitor);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (referencia !== undefined && referencia !== null) {
      parametros = parametros.set('referencia', referencia);
    }

    if (idFornecedor !== undefined && idFornecedor !== null) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if (codErp !== undefined && codErp !== null) {
      parametros = parametros.set('codErp', codErp);
    }

    if (ordemMonitor !== undefined && ordemMonitor !== null) {
      parametros = parametros.set('ordemMonitor', ordemMonitor);
    }

    if (nfe !== undefined && nfe !== null) {
      parametros = parametros.set('nfe', nfe);
    }

    if (tipoLocalizacao !== undefined && tipoLocalizacao !== null) {
      const eRural = tipoLocalizacao === 0 ? '1' : '0';

      parametros = parametros.set('tipoLocalizacao', eRural);
    }

    if (possuiVendaDireta !== undefined && possuiVendaDireta !== null) {
      parametros = parametros.set('possuiVendaDireta', possuiVendaDireta);
    }

    if (vFiltroDescDe != undefined && vFiltroDescDe != null && vFiltroDescAte && vFiltroDescAte) {
      parametros = parametros.set('vFiltroDescDe', vFiltroDescDe);
      parametros = parametros.set('vFiltroDescAte', vFiltroDescAte);
    }

    if (possuiServico !== undefined && possuiServico !== null) {
      parametros = parametros.set('possuiServico', (possuiServico === 1).toString());
    }

    if (tipoFrete !== undefined && tipoFrete !== null) {
      parametros = parametros.set('tipoFrete', tipoFrete);
    }

    if (tipoPendencia !== undefined && tipoPendencia !== null) {
      parametros = parametros.set('tipoPendencia', tipoPendencia);
    }

    if (substituicao !== undefined && substituicao !== null) {
      parametros = parametros.set('substituicao', substituicao);
    }

    if (possuiRespostaAnaliseDesconto !== undefined && possuiRespostaAnaliseDesconto !== null) {
      parametros = parametros.set('possuiRespostaAnaliseDesconto', possuiRespostaAnaliseDesconto);
    }

    if (pesquisarPorTime !== undefined && pesquisarPorTime !== null) {
      parametros = parametros.set('pesquisarPorTime', pesquisarPorTime);
    }

    if (cidadeCd !== undefined && cidadeCd !== null) {
      parametros = parametros.set('cidadeCD', cidadeCd);
    }

    if (codErpProduto !== undefined && codErpProduto !== null) {
      parametros = parametros.set('codErpProduto', codErpProduto);
    }

    return this.http.get(globals.apiUrl + '/api/Pedido/ExportarConsultaMonitor', {
      responseType: 'blob',
      params: parametros
    });
  }

  exportarConsulta(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    inicio,
    fim,
    nomeCliente,
    cupom,
    status,
    vendedor,
    etapas,
    mostrarTodos,
    acompanhamento,
    idIntegrador,
    orcStatus,
    forma?,
    condicao?,
    valorIni?,
    valorFim?,
    tags?,
    monitor?,
    repasse?,
    repasseStatus?,
    tipoFiltroDataMonitor?,
    idUsuarioIntegrador?,
    referencia?,
    idFornecedor?,
    codErp?,
    ordemMonitor?,
    nfe?,
    tipoLocalizacao?,
    possuiVendaDireta?,
    vFiltroDescDe?,
    vFiltroDescAte?,
    possuiServico?,
    tipoFrete?,
    tipoPendencia?,
    pendencias?,
    substituicao?,
    possuiRespostaAnaliseDesconto?,
    pesquisarPorTime?,
    cidadeCd?
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('dInicio', inicio ? inicio : '')
      .set('dFim', fim ? fim : '')
      .set('nomeCliente', nomeCliente ? nomeCliente : '')
      .set('cupom', cupom ? cupom : '')
      .set('status', status !== undefined && status !== null ? status : '')
      .set('vendedor', vendedor !== undefined && vendedor !== null ? vendedor : '')
      .set('etapas', etapas !== undefined && etapas !== null ? etapas : '')
      .set('mostrarTodos', mostrarTodos)
      .set('monitoramento', acompanhamento)
      .set('pendencias', pendencias !== undefined && pendencias !== null ? pendencias : '');

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    if (forma !== undefined && forma !== null) {
      parametros = parametros.set('forma', forma);
    }
    if (condicao !== undefined && condicao !== null) {
      parametros = parametros.set('condicao', condicao);
    }
    if (valorIni !== undefined && valorIni !== null) {
      parametros = parametros.set('valorIni', valorIni);
    }
    if (valorFim !== undefined && valorFim !== null) {
      parametros = parametros.set('valorFim', valorFim);
    }
    if (orcStatus !== undefined && orcStatus !== null) {
      parametros = parametros.set('orcStatus', orcStatus);
    }
    if (tags !== undefined && tags !== null) {
      parametros = parametros.set('tags', tags);
    }
    if (monitor !== undefined && monitor !== null) {
      parametros = parametros.set('monitor', monitor);
    }
    if (repasse !== undefined && repasse !== null) {
      parametros = parametros.set('repasse', repasse);
    }

    if (repasseStatus !== undefined && repasseStatus !== null) {
      parametros = parametros.set('repasseStatus', repasseStatus);
    }

    if (tipoFiltroDataMonitor !== undefined && tipoFiltroDataMonitor !== null) {
      parametros = parametros.set('tipoFiltroDataMonitor', tipoFiltroDataMonitor);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (referencia !== undefined && referencia !== null) {
      parametros = parametros.set('referencia', referencia);
    }

    if (idFornecedor !== undefined && idFornecedor !== null) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if (codErp !== undefined && codErp !== null) {
      parametros = parametros.set('codErp', codErp);
    }

    if (ordemMonitor !== undefined && ordemMonitor !== null) {
      parametros = parametros.set('ordemMonitor', ordemMonitor);
    }

    if (nfe !== undefined && nfe !== null) {
      parametros = parametros.set('nfe', nfe);
    }

    if (tipoLocalizacao !== undefined && tipoLocalizacao !== null) {
      const eRural = tipoLocalizacao === 0 ? '1' : '0';

      parametros = parametros.set('tipoLocalizacao', eRural);
    }

    if (possuiVendaDireta !== undefined && possuiVendaDireta !== null) {
      parametros = parametros.set('possuiVendaDireta', possuiVendaDireta);
    }

    if (vFiltroDescDe != undefined && vFiltroDescDe != null && vFiltroDescAte && vFiltroDescAte) {
      parametros = parametros.set('vFiltroDescDe', vFiltroDescDe);
      parametros = parametros.set('vFiltroDescAte', vFiltroDescAte);
    }

    if (possuiServico !== undefined && possuiServico !== null) {
      parametros = parametros.set('possuiServico', (possuiServico === 1).toString());
    }

    if (tipoFrete !== undefined && tipoFrete !== null) {
      parametros = parametros.set('tipoFrete', tipoFrete);
    }

    if (tipoPendencia !== undefined && tipoPendencia !== null) {
      parametros = parametros.set('tipoPendencia', tipoPendencia);
    }

    if (substituicao !== undefined && substituicao !== null) {
      parametros = parametros.set('substituicao', substituicao);
    }

    if (possuiRespostaAnaliseDesconto !== undefined && possuiRespostaAnaliseDesconto !== null) {
      parametros = parametros.set('possuiRespostaAnaliseDesconto', possuiRespostaAnaliseDesconto);
    }

    if (pesquisarPorTime !== undefined && pesquisarPorTime !== null) {
      parametros = parametros.set('pesquisarPorTime', pesquisarPorTime);
    }

    if (cidadeCd !== undefined && cidadeCd !== null) {
      parametros = parametros.set('cidadeCD', cidadeCd);
    }

    return this.http.get(globals.apiUrl + '/api/Pedido/ExportarConsulta', { responseType: 'blob', params: parametros });
  }

  exportarRepasse(
    campoOrdenacao,
    orientacaoOrdenacao,
    inicio,
    fim,
    nomeCliente,
    cupom,
    status,
    vendedor,
    etapas,
    mostrarTodos,
    acompanhamento,
    idIntegrador,
    orcStatus,
    forma?,
    condicao?,
    valorIni?,
    valorFim?,
    tags?,
    monitor?,
    repasse?,
    repasseStatus?,
    tipoFiltroDataMonitor?,
    idUsuarioIntegrador?,
    referencia?,
    idFornecedor?,
    codErp?,
    filtroClassificacao?,
    ordemMonitor?,
    buscarTags?,
    buscarSeguros?,
    buscarFormasPagamento?,
    buscarCamposPersonalizados?,
    nfe?
  ) {
    let parametros = new HttpParams()
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('dInicio', inicio ? inicio : '')
      .set('dFim', fim ? fim : '')
      .set('nomeCliente', nomeCliente ? nomeCliente : '')
      .set('cupom', cupom ? cupom : '')
      .set('status', status !== undefined && status !== null ? status : '')
      .set('vendedor', vendedor !== undefined && vendedor !== null ? vendedor : '')
      .set('etapas', etapas !== undefined && etapas !== null ? etapas : '')
      .set('mostrarTodos', mostrarTodos)
      .set('monitoramento', acompanhamento);

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    if (forma !== undefined && forma !== null) {
      parametros = parametros.set('forma', forma);
    }
    if (condicao !== undefined && condicao !== null) {
      parametros = parametros.set('condicao', condicao);
    }
    if (valorIni !== undefined && valorIni !== null) {
      parametros = parametros.set('valorIni', valorIni);
    }
    if (valorFim !== undefined && valorFim !== null) {
      parametros = parametros.set('valorFim', valorFim);
    }
    if (orcStatus !== undefined && orcStatus !== null) {
      parametros = parametros.set('orcStatus', orcStatus);
    }
    if (tags !== undefined && tags !== null) {
      parametros = parametros.set('tags', tags);
    }
    if (monitor !== undefined && monitor !== null) {
      parametros = parametros.set('monitor', monitor);
    }
    if (repasse !== undefined && repasse !== null) {
      parametros = parametros.set('repasse', repasse);
    }

    if (repasseStatus !== undefined && repasseStatus !== null) {
      parametros = parametros.set('repasseStatus', repasseStatus);
    }

    if (tipoFiltroDataMonitor !== undefined && tipoFiltroDataMonitor !== null) {
      parametros = parametros.set('tipoFiltroDataMonitor', tipoFiltroDataMonitor);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (referencia !== undefined && referencia !== null) {
      parametros = parametros.set('referencia', referencia);
    }

    if (idFornecedor !== undefined && idFornecedor !== null) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if (codErp !== undefined && codErp !== null) {
      parametros = parametros.set('codErp', codErp);
    }

    if (filtroClassificacao !== undefined && filtroClassificacao !== null) {
      parametros = parametros.set('filtroClassificacao', filtroClassificacao);
    }

    if (ordemMonitor !== undefined && ordemMonitor !== null) {
      parametros = parametros.set('ordemMonitor', ordemMonitor);
    }

    if (buscarTags !== undefined && buscarTags !== null) {
      parametros = parametros.set('buscarTags', buscarTags);
    }

    if (buscarSeguros !== undefined && buscarSeguros !== null) {
      parametros = parametros.set('buscarSeguros', buscarSeguros);
    }

    if (buscarFormasPagamento !== undefined && buscarFormasPagamento !== null) {
      parametros = parametros.set('buscarFormasPagamento', buscarFormasPagamento);
    }

    if (buscarCamposPersonalizados !== undefined && buscarCamposPersonalizados !== null) {
      parametros = parametros.set('buscarCamposPersonalizados', buscarCamposPersonalizados);
    }

    if (nfe !== undefined && nfe !== null) {
      parametros = parametros.set('nfe', nfe);
    }

    return this.http.get(globals.apiUrl + '/api/Pedido/ExportarRepasse', { responseType: 'blob', params: parametros });
  }

  consultarCabecalho(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/Cabecalho', {
      params: parametros
    });
  }

  sumarioPedidoMonitor(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/SumarioPedidoMonitor', {
      params: parametros
    });
  }

  consultarCompleto(idCupom, atualizarValores?, buscarEstoque?, buscarFoto?, buscarFileiras?, duplicando?) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    if (atualizarValores !== undefined && atualizarValores !== null) {
      parametros = parametros.set('atualizarValores', atualizarValores);
    }

    if (buscarEstoque !== undefined && buscarEstoque !== null) {
      parametros = parametros.set('buscarEstoque', buscarEstoque);
    }

    if (buscarFoto !== undefined && buscarFoto !== null) {
      parametros = parametros.set('buscarFoto', buscarFoto);
    }

    if (buscarFileiras !== undefined && buscarFileiras !== null) {
      parametros = parametros.set('buscarFileiras', buscarFileiras);
    }

    if (duplicando !== undefined && duplicando !== null) {
      parametros = parametros.set('duplicando', duplicando);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscaCompleta', {
      params: parametros
    });
  }

  consultarItens(idCupom, atualizarValores?, buscarEstoque?, buscarFoto?, duplicando?) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    if (atualizarValores !== undefined && atualizarValores !== null) {
      parametros = parametros.set('atualizarValores', atualizarValores);
    }

    if (buscarEstoque !== undefined && buscarEstoque !== null) {
      parametros = parametros.set('buscarEstoque', buscarEstoque);
    }

    if (buscarFoto !== undefined && buscarFoto !== null) {
      parametros = parametros.set('buscarFoto', buscarFoto);
    }

    if (duplicando !== undefined && duplicando !== null) {
      parametros = parametros.set('duplicando', duplicando);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarItens', {
      params: parametros
    });
  }

  consultarResumo(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<ResumoPedido>(globals.apiUrl + '/api/Pedido/BuscarResumo', {
      params: parametros
    });
  }

  consultarInfoRegras() {
    return this.http.get<InfoRegraFormula>(globals.apiUrl + '/api/Pedido/BuscarInfoRegras');
  }

  // primeiroPedido(cliente) {
  //   let parametros = new HttpParams()
  //     .set('cliente', cliente);

  //   return this.http.get<any>(globals.apiUrl + '/api/Pedido/VerificaPrimeiroPedido',
  //     {
  //       params: parametros
  //     });
  // }

  consultarProdutosBloqueados(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/VerificarProdutosBloqueados', {
      params: parametros
    });
  }

  consultarSeguros(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarSeguros', {
      params: parametros
    });
  }

  consultarFormasDePagamento(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarFormasDePagamento', {
      params: parametros
    });
  }

  consultarClienteVendaDireta(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarVendaDireta', {
      params: parametros
    });
  }

  consultarResumoFinanceiro(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<Financa[]>(globals.apiUrl + '/api/Pedido/BuscarResumoFinanceiro', {
      params: parametros
    });
  }

  salvar(
    venda: Pedido,
    itens,
    fileiras,
    clienteFaturamento,
    somenteSalvar,
    orcamento,
    salvandoDaLista,
    enderecoDeEntrega,
    respostas
  ) {
    venda.valorDa = Number(venda.valorDa);
    venda.valorProjeto = Number(venda.valorProjeto);
    venda.valorProjetoLiquido = Number(venda.valorProjetoLiquido);
    venda.valorServico = Number(venda.valorServico);

    venda.formasPagamento = venda.formasPagamento.filter((p) => p.idFormaPag !== null && p.idFormaPag);

    return this.http.post(globals.apiUrl + '/api/Pedido/Salvar', {
      venda,
      itens,
      fileiras,
      clienteFaturamento,
      somenteSalvar,
      orcamento,
      salvandoDaLista,
      enderecoDeEntrega,
      respostas
    });
  }

  confirmarOrcamento(
    venda,
    itens,
    fileiras,
    clienteFaturamento,
    somenteSalvar,
    orcamento,
    salvandoDaLista,
    enderecoDeEntrega,
    arquivo,
    respostas
  ) {
    const confirmacao = {
      venda,
      itens,
      fileiras,
      clienteFaturamento,
      somenteSalvar,
      orcamento,
      salvandoDaLista,
      enderecoDeEntrega,
      url: this.utilitarioService.retornaUrlBase(),
      respostas
    };

    const dados = new FormData();
    if (arquivo && arquivo !== null) {
      dados.append('anexo', arquivo);
    }

    dados.append('dados[pedido]', JSON.stringify(confirmacao));

    return this.http.post(globals.apiUrl + '/api/Pedido/ConfirmarOrcamento', dados);
  }

  salvarCupomDesconto(idCupom, cupomDesconto, incluirNoDesconto) {
    return this.http.post(globals.apiUrl + '/api/Pedido/SalvarCupomDesconto', {
      idCupom,
      cupomDesconto,
      incluirNoDesconto
    });
  }

  cancelar(idCupom, idMotivoPerda) {
    let parametros = new HttpParams().set('idCupom', idCupom).set('idMotivoPerda', idMotivoPerda);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/Cancelar', {
      params: parametros
    });
  }

  confirmar(
    idCupom,
    formaPag,
    condPag,
    enderecoEntrega,
    vendaDireta,
    clienteFaturamento,
    resumo,
    financiamento,
    arquivo,
    taxaDA,
    respostas,
    formasPagamento,
    dispEstoque,
    dataDispEstoque,
    nomeResponsavel,
    telefoneResponsavel,
    obs
  ) {
    const confirmacao = {
      idCupom,
      formaPag,
      condPag,
      enderecoEntrega,
      vendaDireta,
      clienteFaturamento,
      resumo,
      financiamento,
      url: this.utilitarioService.retornaUrlBase(),
      taxaDA,
      respostas,
      formasPagamento,
      dispEstoque,
      dataDispEstoque,
      nomeResponsavel,
      telefoneResponsavel,
      obs
    };

    const dados = new FormData();
    if (arquivo && arquivo !== null) {
      dados.append('anexo', arquivo);
    }

    dados.append('dados[confirmacao]', JSON.stringify(confirmacao));

    return this.http.post(globals.apiUrl + '/api/Pedido/Confirmar', dados);
  }

  salvarFinanceiroMercadoPago(idCupom, idPagamento) {
    let parametros = new HttpParams().set('idCupom', idCupom).set('idPagamento', idPagamento);

    return this.http.get<ResumoPedido>(globals.apiUrl + '/api/Pedido/SalvarFinanceiroMercadoPago', {
      params: parametros
    });
  }

  buscarFrete() {
    return this.http.get(globals.apiUrl + '/api/Pedido/BuscarFrete', { responseType: 'text' });
  }

  buscarItensEstrutura(fileiras, cabos?) {
    return this.http.post(globals.apiUrl + '/api/Pedido/BuscarItensEstrutura', { fileiras, cabos });
  }

  testarMP(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/testarMP', {
      params: parametros
    });
  }

  atualizarObservacao(idCupom, observacao, usuarios, privada) {
    return this.http.post(globals.apiUrl + '/api/Pedido/AtualizarObservacao', {
      idCupom,
      observacao,
      usuarios,
      privada
    });
  }

  atualizarPrevisaoEntrega(idCupom, previsaoEntrega) {
    return this.http.post(globals.apiUrl + '/api/Pedido/atualizarPrevisaoEntrega', {
      idCupom,
      previsaoEntrega
    });
  }

  buscarDadosDashboard(
    tipoFiltro,
    inicio?,
    fim?,
    vendedor?,
    integrador?,
    idUsuarioIntegrador?,
    etapas?,
    pesquisaPorTimes?
  ) {
    let parametros = new HttpParams().set('tipoFiltro', tipoFiltro);
    if (inicio && fim) {
      parametros = parametros.set('inicio', inicio).set('fim', fim);
    }
    if (vendedor) {
      parametros = parametros.set('vendedor', vendedor);
    }
    if (integrador) {
      parametros = parametros.set('integrador', integrador);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (etapas !== undefined && etapas.length > 0) {
      parametros = parametros.set('etapas', etapas);
    }

    if (pesquisaPorTimes !== undefined && pesquisaPorTimes !== null) {
      parametros = parametros.set('pesquisaPorTimes', pesquisaPorTimes);
    }

    return this.http.get<Dashboard>(globals.apiUrl + '/api/Pedido/BuscarDadosDashboard', {
      params: parametros
    });
  }

  private filtrosDashboard(
    tipoFiltro,
    inicio?,
    fim?,
    vendedor?,
    integrador?,
    idUsuarioIntegrador?,
    etapas?,
    pesquisaPorTimes?
  ) {
    let parametros = new HttpParams().set('tipoFiltro', tipoFiltro);

    if (inicio && fim) {
      parametros = parametros.set('inicio', inicio).set('fim', fim);
    }

    if (vendedor) {
      parametros = parametros.set('vendedor', vendedor);
    }

    if (integrador) {
      parametros = parametros.set('integrador', integrador);
    }

    if (idUsuarioIntegrador !== undefined && idUsuarioIntegrador !== null) {
      parametros = parametros.set('idUsuarioIntegrador', idUsuarioIntegrador);
    }

    if (etapas !== undefined && etapas.length > 0) {
      parametros = parametros.set('etapas', etapas);
    }

    if (pesquisaPorTimes !== undefined && pesquisaPorTimes !== null) {
      parametros = parametros.set('pesquisaPorTimes', pesquisaPorTimes);
    }

    return parametros;
  }

  buscarResultadosPeriodoDashboard(
    tipoFiltro,
    inicio?,
    fim?,
    vendedor?,
    integrador?,
    idUsuarioIntegrador?,
    etapas?,
    pesquisaPorTimes?
  ) {
    const parametros = this.filtrosDashboard(
      tipoFiltro,
      inicio,
      fim,
      vendedor,
      integrador,
      idUsuarioIntegrador,
      etapas,
      pesquisaPorTimes
    );

    return this.http.get<ResultadosPeriodoDashboard>(globals.apiUrl + '/api/Pedido/BuscarResultadosPeriodoDashboard', {
      params: parametros
    });
  }

  buscarUltimosOrcamentos(
    tipoFiltro,
    inicio?,
    fim?,
    vendedor?,
    integrador?,
    idUsuarioIntegrador?,
    etapas?,
    pesquisaPorTimes?
  ) {
    const parametros = this.filtrosDashboard(
      tipoFiltro,
      inicio,
      fim,
      vendedor,
      integrador,
      idUsuarioIntegrador,
      etapas,
      pesquisaPorTimes
    );

    return this.http.get<any[]>(globals.apiUrl + '/api/Pedido/BuscarUltimosOrcamentos', {
      params: parametros
    });
  }

  buscarUltimosPedidos(
    tipoFiltro,
    inicio?,
    fim?,
    vendedor?,
    integrador?,
    idUsuarioIntegrador?,
    etapas?,
    pesquisaPorTimes?
  ) {
    const parametros = this.filtrosDashboard(
      tipoFiltro,
      inicio,
      fim,
      vendedor,
      integrador,
      idUsuarioIntegrador,
      etapas,
      pesquisaPorTimes
    );

    return this.http.get<any[]>(globals.apiUrl + '/api/Pedido/BuscarUltimosPedidos', {
      params: parametros
    });
  }

  buscarResultVendasUltOrcPed(
    tipoFiltro,
    inicio?,
    fim?,
    vendedor?,
    integrador?,
    idUsuarioIntegrador?,
    etapas?,
    pesquisaPorTimes?
  ) {
    const parametros = this.filtrosDashboard(
      tipoFiltro,
      inicio,
      fim,
      vendedor,
      integrador,
      idUsuarioIntegrador,
      etapas,
      pesquisaPorTimes
    );

    return this.http.get<ResultVendasUltOrcPed>(globals.apiUrl + '/api/Pedido/BuscarResultVendasUltOrcPed', {
      params: parametros
    });
  }

  buscarDadosGraficos(
    tipoFiltro,
    inicio?,
    fim?,
    vendedor?,
    integrador?,
    idUsuarioIntegrador?,
    etapas?,
    pesquisaPorTimes?
  ) {
    const parametros = this.filtrosDashboard(
      tipoFiltro,
      inicio,
      fim,
      vendedor,
      integrador,
      idUsuarioIntegrador,
      etapas,
      pesquisaPorTimes
    );

    return this.http.get<ResultDadosGraficos>(globals.apiUrl + '/api/Pedido/BuscarDadosGraficos', {
      params: parametros
    });
  }

  buscarDadosTotais(
    tipoFiltro,
    inicio?,
    fim?,
    vendedor?,
    integrador?,
    idUsuarioIntegrador?,
    etapas?,
    pesquisaPorTimes?
  ) {
    const parametros = this.filtrosDashboard(
      tipoFiltro,
      inicio,
      fim,
      vendedor,
      integrador,
      idUsuarioIntegrador,
      etapas,
      pesquisaPorTimes
    );

    return this.http.get<ResultTotais>(globals.apiUrl + '/api/Pedido/BuscarDadosTotais', {
      params: parametros
    });
  }

  buscarStringBoxConectorDoInversor(idInversor, qtdInversor, idPainel, idFornecedorPainel) {
    let parametros = new HttpParams()
      .set('idInversor', idInversor)
      .set('qtdInversor', qtdInversor)
      .set('idPainel', idPainel);

    if (idFornecedorPainel !== undefined && idFornecedorPainel !== null) {
      parametros = parametros.set('idFornecedorPainel', idFornecedorPainel);
    }

    return this.http.get<ItemPedido[]>(globals.apiUrl + '/api/Pedido/BuscarStringBoxConectorDoInversor', {
      params: parametros
    });
  }

  buscarFornecedoresEstrutura(fileira) {
    return this.http.post<any>(globals.apiUrl + '/api/Pedido/BuscarFornecedoresEstrutura', fileira);
  }

  atualizarFileira(fileira) {
    return this.http.post<any>(globals.apiUrl + '/api/Pedido/AtualizarFileira', fileira);
  }

  buscarCombinacoes(filtro) {
    return this.http.post<any>(globals.apiUrl + '/api/Pedido/BuscarCombinacoes', filtro);
  }

  buscarCombinacao(filtro) {
    return this.http.post<any>(globals.apiUrl + '/api/Pedido/BuscarCombinacao', filtro);
  }

  calculoGeracao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/CalculoGeracao');
  }

  validarCombinacao(itens) {
    return this.http.post(globals.apiUrl + '/api/Pedido/ValidarCombinacao', itens);
  }

  atualizarStatusDoOrcamento(idCupom, idStatus, tipo) {
    return this.http.post<any>(
      globals.apiUrl + '/api/Pedido/' + (tipo === 0 ? 'AtualizarStatusDoOrcamento' : 'AtualizarStatusDoRepasse'),
      { idCupom, idStatus }
    );
  }

  baixarTermoRepasse() {
    return this.http.get(globals.apiUrl + '/api/Pedido/BaixarTermoRepasse', { responseType: 'blob' });
  }

  baixarTermo() {
    return this.http.get(globals.apiUrl + '/api/Pedido/BaixarTermo', { responseType: 'blob' });
  }
  buscarFornecedoresPorTelhado(telhado) {
    let parametros = new HttpParams().set('telhado', telhado);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarFornecedoresEstruturaPorTelhado', {
      params: parametros
    });
  }

  buscarEnderecoDeEntrega(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);
    return this.http.get<VendaEntrega>(globals.apiUrl + '/api/Pedido/BuscarEnderecoDeEntrega', {
      params: parametros
    });
  }

  salvarTags(idCupom, tags) {
    return this.http.post<any>(globals.apiUrl + '/api/Pedido/SalvarTags', { idCupom, tags });
  }

  salvarPendencias(idCupom, pendencias) {
    return this.http.post<any>(globals.apiUrl + '/api/Pedido/SalvarPendencias', { idCupom, pendencias });
  }

  atualizarAnotacaoStatus(idCupom, anotacao) {
    return this.http.post<any>(globals.apiUrl + '/api/Pedido/AtualizarAnotacaoStatus', { idCupom, anotacao });
  }

  atualizarCodigoFiname(idCupom, codFiname) {
    return this.http.post<any>(globals.apiUrl + '/api/Pedido/AtualizarCodigoFiname', { idCupom, codFiname });
  }

  buscarCryptCupomFotus(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarCryptCupomFotus', {
      params: new HttpParams().set('idCupom', idCupom)
    });
  }

  buscarListaArqBoleto(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarListaArqBoleto', {
      params: new HttpParams().set('idCupom', idCupom)
    });
  }

  baixarBoletoPedido(idCupom, fileName) {
    return this.http.get(globals.apiUrl + '/api/Pedido/BaixarBoletoPedido', {
      params: new HttpParams().set('idCupom', idCupom).set('fileName', fileName),
      responseType: 'blob'
    });
  }

  calcularEstoqueLote(itens, idCD, idCupom, orcamento) {
    return this.http.post<any>(globals.apiUrl + '/api/Pedido/CalcularEstoqueLote', {
      itens,
      idCD,
      idCupom: idCupom === null || idCupom === undefined ? null : idCupom,
      orcamento
    });
  }

  atualizarApelido(idCupom, apelido) {
    return this.http.post(globals.apiUrl + '/api/Pedido/AtualizarApelido', {
      idCupom,
      apelido
    });
  }

  calcular(dados: DadosCalculo) {
    // if (dados && dados.formasPagamento !== null && dados.formasPagamento !== undefined) {
    //   dados.formasPagamento = dados.formasPagamento.map((forma) => ({
    //     ...forma,
    //     valor: forma.valor === null || forma.valor === undefined ? 0 : Number(forma.valor),
    //     total: forma.total === null || forma.total === undefined ? 0 : Number(forma.total)
    //   }));
    // }

    return this.http.post<DadosCalculo>(globals.apiUrl + '/api/Pedido/Calcular', dados);
  }

  calcularFormasDePagamento(formas, valorParaFormas, valorTotal) {
    return this.http.post<VendaFormaPag[]>(globals.apiUrl + '/api/Pedido/CalcularFormasDePagamento', {
      formas,
      valorParaFormas,
      valorTotal
    });
  }

  calcularDescontoMaximo(idCliente, idVendedor, da, cupom) {
    let parametros = new HttpParams().set('idCliente', idCliente);

    if (idVendedor !== undefined && idVendedor !== null) {
      parametros = parametros.set('idVendedor', idVendedor);
    }

    if (da !== undefined && da !== null) {
      parametros = parametros.set('da', da);
    }

    if (cupom !== undefined && cupom !== null) {
      parametros = parametros.set('cupom', cupom);
    }

    return this.http.get<number>(globals.apiUrl + '/api/Pedido/CalcularDescontoMaximo', {
      params: parametros
    });
  }

  calcularDescAcresInicial(idCliente, idVendedor, da) {
    let parametros = new HttpParams().set('idCliente', idCliente);

    if (idVendedor !== undefined && idVendedor !== null) {
      parametros = parametros.set('idVendedor', idVendedor);
    }

    if (da !== undefined && da !== null) {
      parametros = parametros.set('da', da);
    }

    return this.http.get<number>(globals.apiUrl + '/api/Pedido/CalcularDescAcresInicial', {
      params: parametros
    });
  }

  calcularValorFinal(
    idCliente,
    origem,
    valor,
    idFornecedor,
    potencia,
    descontoIndividual,
    percentual,
    valorDa,
    ibge,
    itens?
  ) {
    // let parametros = new HttpParams()
    //   .set('idCliente', idCliente).set('origem', origem).set('valor', valor);

    // if (idFornecedor !== undefined && idFornecedor !== null) {
    //   parametros = parametros.set('idFornecedor', idFornecedor);
    // }

    // if (potencia !== undefined && potencia !== null) {
    //   parametros = parametros.set('potencia', potencia);
    // }

    // if (descontoIndividual !== undefined && descontoIndividual !== null) {
    //   parametros = parametros.set('descontoIndividual', descontoIndividual);
    // }

    // if (percentual !== undefined && percentual !== null) {
    //   parametros = parametros.set('percentual', percentual);
    // }

    // if (valorDa !== undefined && valorDa !== null) {
    //   parametros = parametros.set('valorDa', valorDa);
    // }

    // if (ibge !== undefined && ibge !== null) {
    //   parametros = parametros.set('ibge', ibge);
    // }

    return this.http.post<number>(globals.apiUrl + '/api/Pedido/CalcularValorFinal', {
      idCliente,
      origem,
      valor,
      idFornecedor,
      potencia,
      descontoIndividual,
      percentual,
      valorDa,
      ibge,
      itens
    });
  }

  reativarOrcPedExpirado(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/ReativarOrcPedExpirado', {
      params: parametros
    });
  }

  buscarLimDescVendedorPedido(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarLimDescVendedorPedido', {
      params: parametros
    });
  }

  buscarTotalItens(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<any>(globals.apiUrl + '/api/Pedido/BuscarTotalItens', {
      params: parametros
    });
  }

  usuarioPodeCancelar(idCupom: string): Observable<boolean> {
    return this.http.get<boolean>(`${globals.apiUrl}/api/Pedido/UsuarioPodeCancelar`, { params: { idCupom } });
  }

  usuarioPodeAcessarOrcPed(idCupom: string): Observable<boolean> {
    return this.http.get<boolean>(`${globals.apiUrl}/api/Pedido/PodeAcessarOrcPed`, { params: { idCupom } });
  }

  buscarDadosPedidoParaAnaliseDesconto(idCupom: string): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/Pedido/BuscarDadosPedidoParaAnaliseDesconto`, {
      params: { idCupom }
    });
  }

  buscarDadosPedidoParaFinSimulacao(idCupom: string): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/Pedido/BuscarDadosPedidoParaFinSimulacao`, {
      params: { idCupom }
    });
  }

  criarReferenciaMercadoPago(idCupom: string) {
    return this.http.get<any>(`${globals.apiUrl}/api/Pedido/CriarReferenciaMercadoPago`, {
      params: { idCupom, url: this.utilitarioService.retornaUrlBase() }
    });
  }

  consultarLogVendaCupom(idCupom) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    return this.http.get<LogVendaCupom>(globals.apiUrl + '/api/LogVendaCupom/BuscarUltimoLogDisp', {
      params: parametros
    });
  }

  consultarLogVendaCupomComPaginacao(
    descricao: string,
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    idCupom
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('idCupom', idCupom);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/LogVendaCupom/ListaPag', {
      params: parametros
    });
  }

  podeVerSubstituicao(idCupom: string) {
    return this.http.get<any>(`${globals.apiUrl}/api/Pedido/PodeVerSubstituicao`, { params: { idCupom } });
  }

  buscarFileiras(idCupom: string) {
    return this.http.get<any>(`${globals.apiUrl}/api/Pedido/BuscarFileiras`, { params: { idCupom } });
  }

  existeRastreio(idCupom: string) {
    return this.http.get<any>(`${globals.apiUrl}/api/Pedido/ExisteRastreio`, { params: { idCupom } });
  }

  buscarLinkRastreio(idCupom: string, codErp: string) {
    let parametros = new HttpParams().set('idCupom', idCupom).set('codErp', codErp);

    return this.http.get<any>(`${globals.apiUrl}/api/Pedido/BuscarLinkRastreio`, { params: parametros });
  }

  buscarNumeroPedido(id) {
    let parametros = new HttpParams().set('id', id);

    return this.http.get<any>(`${globals.apiUrl}/api/Pedido/BuscarNumeroPedido`, { params: parametros });
  }

  setFormaPagPedido(pedido: Pedido | PedidoLista, idFormaPag) {
    if (
      pedido.formasPagamento === null ||
      pedido.formasPagamento === undefined ||
      pedido.formasPagamento.length === 0
    ) {
      const forma = new VendaFormaPag();
      forma.idFormaPag = idFormaPag;
      pedido.formasPagamento = [];
      pedido.formasPagamento.push(forma);
    } else {
      pedido.formasPagamento[0].idFormaPag = idFormaPag;
    }
  }

  setCondPagPedido(pedido: Pedido | PedidoLista, idCondPag) {
    if (
      pedido.formasPagamento === null ||
      pedido.formasPagamento === undefined ||
      pedido.formasPagamento.length === 0
    ) {
      const forma = new VendaFormaPag();
      forma.idCondPag = idCondPag;
      pedido.formasPagamento = [];
      pedido.formasPagamento.push(forma);
    } else {
      pedido.formasPagamento[0].idCondPag = idCondPag;
    }
  }
}
